export const EMAIL_SERVICE_MODAL_OPENED = 'EMAIL_SERVICE_MODAL_OPENED' as const;
export const EMAIL_SERVICE_MODAL_CLOSED = 'EMAIL_SERVICE_MODAL_CLOSED' as const;
export const EMAIL_SERVICE_RECIPIENT_CHANGED = 'EMAIL_SERVICE_RECIPIENT_CHANGED' as const;
export const EMAIL_SERVICE_DOCUMENTS_CHANGED = 'EMAIL_SERVICE_DOCUMENTS_CHANGED' as const;

export const EMAIL_SERVICE_FORM_SUBMISSION_REQUESTED = 'EMAIL_SERVICE_FORM_SUBMISSION_REQUESTED' as const;
export const EMAIL_SERVICE_FORM_SUBMISSION_FAILED = 'EMAIL_SERVICE_FORM_SUBMISSION_FAILED' as const;
export const EMAIL_SERVICE_FORM_SUBMITTED = 'EMAIL_SERVICE_FORM_SUBMITTED' as const;

export const EMAIL_SERVICE_PREVIEW_CONTENT_RECEIVED = 'EMAIL_SERVICE_PREVIEW_CONTENT_RECEIVED' as const;
export const EMAIL_SERVICE_PREVIEW_CONTENT_FAILED = 'EMAIL_SERVICE_PREVIEW_CONTENT_FAILED' as const;
